<p-toast></p-toast>
<div style="text-align-last: right;">
    <p-button type="button" [style]="{'margin':'20px'}" label="Add Version" class="p-button-lg" icon="pi pi-plus"
        (click)="createDialogFn(true)"></p-button>
</div>
<div style="float:right">
    <i class="pi pi-chevron-left" (click)="prevPage()" pTooltip="Previous Page"
        style="cursor: pointer;font-size: 200%;"></i>
    <i class="pi pi-chevron-right" (click)="nextPage()" pTooltip="Next Page" style="cursor: pointer;font-size:200%"></i>
</div>
<br>
<br>
<div class="table-responsive text-center justify-content-center"
    style="font-size:14px; margin-bottom: 20px;text-align: center;vertical-align: center;">
    <p-table [value]="versionList" [rows]="10" [loading]="posting" [globalFilterFields]="[]" [scrollable]="true">
        <ng-template pTemplate="header">
            <tr>
                <th><b>App Version</b></th>
                <th><b>App Min Version</b></th>
                <th><b>Platform</b></th>
                <th><b>Created at</b></th>
                <th><b>Delete</b></th>
            </tr>
        </ng-template>
        <ng-template pTemplate="body" let-version>
            <tr>
                <td>{{version.app_version}}</td>
                <td>{{version.app_min_version}}</td>
                <td>{{version.platform}}</td>
                <td>{{version.created_at | date:'medium'}}</td>
                <td>
                    <button pButton pRipple type="button" icon="pi pi-trash" label="Delete" class="p-button-warning"
                        (click)="delete(version.app_guid)"></button>
                </td>
            </tr>
        </ng-template>
    </p-table>
</div>

<div class="row container justify-content-center text-center alert alert-danger"
    *ngIf="tableResponse.success!=null && tableResponse.success==false">
    <p *ngIf="tableResponse.error!=null">{{tableResponse.error.message}}</p>
    <div *ngIf="serverError?.error!=null && serverError?.statusCode!=500">
        <p *ngFor="let message of serverError?.message">{{message}}</p>
    </div>
    <div *ngIf="serverError?.error!=null && serverError?.statusCode==500">
        <p>{{serverError?.message}}</p>
    </div>

</div>

<p-dialog header="Add new version" *ngIf="createDialog" [(visible)]="createDialog"
    (onHide)="createDialogFn(false)" [style]="{width: '50vw'}">
    <form accept-charset="UTF-8" #createForm="ngForm" (ngSubmit)="create()">
        <div class="card">
            <div class="p-field p-grid">
                <label for ="hg" class="p-col-fixed" style="width:100px">App Version</label>
                <div class="p-col">
                    <input id="hg" type="text" [(ngModel)]="createBody.app_version" name="app_ver" #app_ver='ngModel'
                        maxlength='50' pInputText />
                </div>
                <div *ngIf="(app_ver.invalid && (app_ver.dirty || app_ver.touched))" class="alert alert-danger">
                    <div *ngIf="app_ver.errors.required" class="invalid">
                        App Version is required
                    </div>
                </div>
            </div>
            <div class="p-field p-grid">
                <label class="p-col-fixed" style="width:100px">Minimum App Version</label>
                <div class="p-col">
                    <input type="text" [(ngModel)]="createBody.app_min_version" name="app_min_ver"
                        #app_min_ver='ngModel' maxlength='50' pInputText />
                </div>
                <div *ngIf="(app_min_ver.invalid && (app_min_ver.dirty || app_min_ver.touched))"
                    class="alert alert-danger">
                    <div *ngIf="app_min_ver.errors.required" class="invalid">
                        Minimum App Version is required
                    </div>
                </div>
            </div>
            <div class="p-field p-grid">
                <label class="p-col-fixed" style="width:100px">Platform</label>
                <div class="p-col">
                    <p-dropdown [options]="platform_list" [(ngModel)]="createBody.platform" name="app_platform"
                        #app_platform='ngModel' required></p-dropdown>
                </div>
                <div *ngIf="(app_platform.invalid && (app_platform.dirty || app_platform.touched))"
                    class="alert alert-danger">
                    <div *ngIf="app_platform.errors.required" class="invalid">
                        Platform is required
                    </div>
                </div>
            </div>

        </div>
        <button type="submit" pButton label="Submit" icon="pi pi-check"
            [disabled]="!createForm.valid || loading"></button>

        <p-progressSpinner [style]="{width: '50px', height: '50px'}" *ngIf="loading" strokeWidth="6">
        </p-progressSpinner>
        <div class="row container justify-content-center text-center alert alert-danger"
            *ngIf="response.success!=null && response.success==false">
            <p *ngIf="response.error!=null">{{response.error.message}}</p>
            <div *ngIf="serverError?.error!=null && serverError?.statusCode!=500">
                <p *ngFor="let message of serverError?.message">{{message}}</p>
            </div>
            <div *ngIf="serverError?.error!=null && serverError?.statusCode==500">
                <p>{{serverError?.message}}</p>
            </div>

        </div>
    </form>

</p-dialog>
